export default __webpack_public_path__ + "static/media/02-model.e3538310.gif";